import { LayoutRenderLayoutItemOptions } from '../../../models/cv-layout-render.model';
import { TabSectionMode } from './tabs-section.options';

export class TabsSectionButtonOptions extends LayoutRenderLayoutItemOptions {
	dropdownOptions?: any[];
	tabSectionMode: TabSectionMode;

	constructor() {
		super();
		this.dropdownOptions = [];
		this.tabSectionMode = TabSectionMode.TAB;
	}
}
